<script lang="ts" setup>
import ReferenceCache from '@/views/references/ReferenceCache.vue'
import { type PublishReferenceProps } from '@/views/references/types'

const props = defineProps<PublishReferenceProps>()
</script>
<template>
  <ReferenceCache v-bind="props" />
</template>
